import moment from 'moment';
import { DATE_TIME_FORMAT } from './constants';
import { UnixTimestamp } from '@module/assignment';
export var getDateTime = function getDateTime(unixTime) {
  var unixTimestampInSecond = UnixTimestamp.isInSecondType(unixTime.toString()) ? unixTime : unixTime / 1000;
  return moment.unix(unixTimestampInSecond).format(DATE_TIME_FORMAT);
};
export var getTimeStr = function getTimeStr(seconds, timeTranslation) {
  var formattedDuration = moment.utc(moment.duration(seconds, 'seconds').asMilliseconds()).format("H [".concat(timeTranslation.h, "] m [").concat(timeTranslation.m, "] s [").concat(timeTranslation.s, "]"));
  return formattedDuration;
};
export var unixTimeToDateTime = function unixTimeToDateTime(unixTime) {
  var unixTimestampDigits = 13;
  var secondsMultiplier = 1000;
  var isMilliseconds = unixTime.length === unixTimestampDigits;
  var timeStamp = isMilliseconds ? parseInt(unixTime, 10) : parseInt(unixTime, 10) * secondsMultiplier;
  return getDateTime(timeStamp / secondsMultiplier);
};